<template>
  <router-link tag='button'   to="/parametrage"  class="button" :style="{ color: color, background: background }"  :class="{ borderStyle: border }">
    <slot></slot>
  </router-link>
</template>

<script>
export default {
      name:"buttonElement",
       props: {
         color: {
          type: String,
          default: '#FCFCFC',

      },
      background: {
          type: String,
          default: '#34B9BB'
      },
      border :{
          type: Boolean,
          default: false,
      }

      
  },
   
}
</script>
